<template>
  <custom-dialog
    :show="show"
    :title="$t('dialog.open.add_manu')"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="398"
  >
    <div class="flex form" slot="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item
          :label="$t(item.label) + '：'"
          v-for="item in currentFormItem"
          :key="item.key"
          :prop="item.key"
        >
          <template v-if="item.inputType == 'select'">
            <el-select
              v-model="form[item.key]"
              style="width: 268px"
              size="small"
              :placeholder="$t(item.label)"
            >
              <el-option
                v-for="option in $t(item.selectKey)"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.inputType == 'input'">
            <template v-if="item.key == 'elevation'">
              <div class="flex">
                <el-input
                  v-model="form[item.key]"
                  :placeholder="$t(item.label)"
                ></el-input>
                <span style="margin: 0 12px">m</span>
                <el-button type="primary" class="btn save" size="small">
                  {{ $t("label.model.getLonlat") }}
                </el-button>
              </div>
            </template>
            <template v-else>
              <el-input
                size="small"
                style="width: 268px"
                v-model="form[item.key]"
                :placeholder="$t(item.label)"
              ></el-input>
            </template>
          </template>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="add">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import { addThird } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 校验账号
    var validateSN = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    return {
      formItem: [
        {
          label: "dialog.open.manu_name",
          key: "name",
          inputType: "input",
        },
      ],
      form: {
        name: "",
      },
      rules: {
        name: [{ required: true, validator: validateSN, trigger: "blur" }],
      },
    };
  },
  computed: {
    title() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.$t("dialog.userList.edit_manu") + "-" + this.rowInfo.name;
      } else {
        return this.$t("dialog.userList.add_manu");
      }
    },
    currentFormItem() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.formItem.filter(
          (f) => f.key == "accountType" || f.key == "contact"
        );
      } else {
        return this.formItem;
      }
    },
  },
  watch: {
    show: {
      handler(val) {
        this.form = {
          name: "",
        };
      },
      deep: true,
    },
  },
  methods: {
    handleClose(done) {
      this.$emit("toggleShow", false);
      this.$refs.form.clearValidate();
    },
    add() {
      if (!this.form.name) return;
      let param = {
        name: this.form.name,
      };
      addThird(param).then((res) => {
        if (res.code == 200) {
          this.handleClose();
          this.$emit("refush");
        }
        this.$message({
          message: res.message,
          type: res.code == 200 ? "success" : "error",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;
}
</style>
